(() => {
  const DISMISS_KEY = 'nugina_popup_dismissed_at';
  const DISMISS_DAYS = 7;
  const instances = new WeakMap();
  function dismissed() {
    try {
      const timestamp = Number(localStorage.getItem(DISMISS_KEY));
      const age = Date.now() - timestamp;
      return timestamp > 0 && Number.isFinite(age) && age >= 0 && age < DISMISS_DAYS * 86400000;
    } catch { return false; }
  }
  function markDismissed() { try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch { /* Storage can be unavailable. */ } }
  function initialize(root = document) {
    if (document.querySelector('[data-newsletter-success]')) markDismissed();
    root.querySelectorAll('[data-newsletter-popup]').forEach((dialog) => {
      if (instances.has(dialog)) return;
      let elapsed = false;
      let engaged = false;
      let requested = false;
      let requestedSource = 'engaged_scroll';
      let opened = false;
      let disposed = false;
      let previousFocus;
      const formId = dialog.dataset.popupForm;
      const returnedToForm = location.hash === `#${formId}`;
      const serverFeedback = returnedToForm && dialog.querySelector('[data-newsletter-success], [data-newsletter-errors]');
      const success = returnedToForm && dialog.querySelector('[data-newsletter-success]');
      const enabled = dialog.dataset.popupEnabled === 'true';
      const delay = Math.max(0, Number(dialog.dataset.popupDelay) || 12) * 1000;
      function open(source) {
        if (disposed || !dialog.isConnected || opened || typeof dialog.showModal !== 'function') return;
        if (!serverFeedback && (!enabled || dismissed() || !elapsed)) return;
        if (!serverFeedback && !requested && !engaged) return;
        if (document.querySelector('dialog[open]')) { requested = true; requestedSource = source; return; }
        const tags = dialog.querySelector('[data-newsletter-tags]');
        if (tags) tags.value = `newsletter,nugina_popup_${source}`;
        previousFocus = document.activeElement;
        dialog.showModal();
        document.body.classList.add('dialog-open');
        opened = true;
        if (success) markDismissed();
      }
      function scroll() {
        engaged = engaged || window.scrollY >= Math.min(320, window.innerHeight * 0.35);
        if (engaged) open('engaged_scroll');
      }
      function exit(event) { if (elapsed && event.clientY <= 0) { requested = true; open('exit_intent'); } }
      function otherClosed(event) { if (event.target !== dialog && requested) queueMicrotask(() => open(requestedSource)); }
      function close() {
        markDismissed();
        if (!document.querySelector('dialog[open]')) document.body.classList.remove('dialog-open');
        previousFocus?.focus({ preventScroll: true });
      }
      function outside(event) {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }
      const timer = setTimeout(() => { elapsed = true; scroll(); }, delay);
      window.addEventListener('scroll', scroll, { passive: true });
      document.documentElement.addEventListener('mouseleave', exit);
      document.addEventListener('close', otherClosed, true);
      dialog.addEventListener('close', close);
      dialog.addEventListener('click', outside);
      if (serverFeedback) open('return');
      instances.set(dialog, () => {
        disposed = true;
        clearTimeout(timer);
        window.removeEventListener('scroll', scroll);
        document.documentElement.removeEventListener('mouseleave', exit);
        document.removeEventListener('close', otherClosed, true);
        dialog.removeEventListener('close', close);
        dialog.removeEventListener('click', outside);
        if (dialog.open) dialog.close();
        if (!document.querySelector('dialog[open]')) document.body.classList.remove('dialog-open');
        instances.delete(dialog);
      });
    });
  }
  document.addEventListener('click', async (event) => {
    const close = event.target.closest('[data-newsletter-close]');
    if (close) close.closest('dialog')?.close();
    const copy = event.target.closest('[data-copy-newsletter-code]');
    if (!copy) return;
    const status = copy.closest('form').querySelector('[data-copy-status]');
    try { await navigator.clipboard.writeText(copy.dataset.copyNewsletterCode); status.textContent = 'Rabattkoden är kopierad.'; }
    catch { status.textContent = 'Markera och kopiera koden manuellt.'; }
  });
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-newsletter-popup]').forEach((dialog) => instances.get(dialog)?.()));
})();
